(() => {
  'use strict';
  const foods = ['bread', 'muesli', 'egg', 'drink'];
  const labels = {plate: 'Teller', knife: 'Messer', bowl: 'Müslischale', spoon: 'Müslilöffel', eggcup: 'Eierbecher', eggspoon: 'Eierlöffel', cup: 'Becher', butter: 'Butterdose', butterknife: 'Serviermesser für Butter', jug: 'Kanne', milk: 'Milchkännchen'};
  const foodNames = {bread: 'Brot', muesli: 'Müsli', egg: 'Ei', drink: 'Heißgetränk'};
  function calculate(people, extras = {}) {
    const perPerson = people.map(person => {
      const items = {};
      if (person.bread) { items.plate = 1; items.knife = 1; }
      if (person.muesli) { items.bowl = 1; items.spoon = 1; }
      if (person.egg) { items.eggcup = 1; items.eggspoon = 1; }
      if (person.drink) items.cup = 1;
      return items;
    });
    const totals = {};
    perPerson.forEach(items => Object.entries(items).forEach(([key, count]) => { totals[key] = (totals[key] || 0) + count; }));
    const eligible = {butter: people.some(p => p.bread), jug: people.some(p => p.drink), milk: people.some(p => p.drink || p.muesli)};
    const shared = {};
    if (extras.butter && eligible.butter) { shared.butter = 1; shared.butterknife = 1; }
    if (extras.jug && eligible.jug) shared.jug = 1;
    if (extras.milk && eligible.milk) shared.milk = 1;
    return {perPerson, totals, eligible, shared};
  }
  // The same pure calculation is exercised offline; no browser global is created.
  if (typeof module === 'object' && module.exports) { module.exports = {calculate, labels}; return; }
  function list(node, items, receipt, empty) {
    const fragment = document.createDocumentFragment();
    const keys = Object.keys(labels).filter(key => items[key]);
    keys.forEach(key => {
      const li = document.createElement('li');
      if (receipt) {
        const name = document.createElement('span'); name.textContent = labels[key];
        const count = document.createElement('strong'); count.textContent = String(items[key]); li.append(name, count);
      } else li.textContent = `${items[key]} ${labels[key]}`;
      fragment.append(li);
    });
    if (!keys.length) { const li = document.createElement('li'); li.textContent = empty; fragment.append(li); }
    node.replaceChildren(fragment);
  }
  function init(scope = document) {
    scope.querySelectorAll('.cs-fruehstueck').forEach(root => {
      if (root.dataset.initialized) return;
      const planner = root.querySelector('[data-planner]');
      if (!planner) return;
      root.dataset.initialized = 'true';
      const places = [...planner.querySelectorAll('[data-person]')];
      const countSelect = planner.querySelector('[data-people]');
      const extraInputs = [...planner.querySelectorAll('[data-extra]')];
      function update() {
        const count = countSelect.value === '1' ? 1 : 2;
        const people = places.slice(0, count).map(place => Object.fromEntries(foods.map(key => [key, place.querySelector(`[data-food="${key}"]`).checked])));
        const extras = Object.fromEntries(extraInputs.map(input => [input.dataset.extra, input.checked]));
        const result = calculate(people, extras);
        extraInputs.forEach(input => { input.disabled = !result.eligible[input.dataset.extra]; if (input.disabled) input.checked = false; });
        places.forEach((place, index) => {
          place.hidden = index >= count;
          if (index >= count) return;
          const person = people[index];
          const selected = foods.filter(key => person[key]);
          place.querySelector('[data-place-title]').textContent = selected.length ? selected.map(key => foodNames[key]).join(', ') : 'Wähle dein Frühstück';
          place.querySelectorAll('[data-item]').forEach(item => item.toggleAttribute('hidden', !person[item.dataset.item]));
          place.querySelector('[data-item="muesli"]').setAttribute('transform', person.bread ? 'translate(250 188) scale(.72)' : 'translate(150 184)');
          place.querySelector('[data-empty]').toggleAttribute('hidden', selected.length > 0);
          const parts = result.perPerson[index];
          place.querySelector('[data-drawing-title]').textContent = `Schematisches Gedeck für Platz ${index + 1}: ${selected.length ? Object.keys(parts).map(k => labels[k]).join(', ') : 'noch keine Auswahl'}`;
          list(place.querySelector('[data-person-list]'), parts, false, 'Wähle oben aus, was du frühstückst.');
        });
        planner.querySelector('.cs-fruehstueck-places').dataset.count = String(count);
        planner.querySelector('[data-person-count]').textContent = count === 1 ? '1 Platz' : '2 Plätze';
        list(planner.querySelector('[data-total-list]'), result.totals, true, 'Noch keine Gedeckteile ausgewählt.');
        list(planner.querySelector('[data-shared-list]'), result.shared, true, 'Keine gemeinsamen Teile ausgewählt.');
      }
      planner.querySelectorAll('[data-controls]').forEach(control => { control.hidden = false; });
      planner.addEventListener('change', update);
      planner.querySelector('[data-reset]').addEventListener('click', () => {
        countSelect.value = '2';
        places.forEach((place, index) => place.querySelectorAll('[data-food]').forEach(input => { input.checked = index === 0 ? ['bread', 'egg', 'drink'].includes(input.dataset.food) : ['muesli', 'drink'].includes(input.dataset.food); }));
        extraInputs.forEach(input => { input.checked = input.dataset.extra !== 'milk'; });
        update();
      });
      root.addEventListener('click', event => {
        const anchor = event.target.closest('a[href^="#"]');
        if (!anchor) return;
        const target = document.getElementById(anchor.hash.slice(1));
        if (target?.hasAttribute('tabindex')) target.focus({preventScroll: true});
      });
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
